"use client";

import React, { useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const projects = [{
  id: "project-1",
  title: "House of Contrast",
  location: "Tennessee, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/8519e210-6768-45ab-bed8-8646a34ef2961.jpg?v=5sqksifj2u3",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/8519e210-6768-45ab-bed8-8646a34ef2961.jpg?v=5sqksifj2u3-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/8519e210-6768-45ab-bed8-8646a34ef2961.jpg?v=5sqksifj2u3-wvc-sizes",
  alt: "House of Contrast luxury architecture and interior design in Tennessee"
}, {
  id: "project-2",
  title: "House 303",
  location: "Michigan, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/90afa795-9cb7-4cfa-9353-6833354e4725.png?v=obnwksujsur",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/90afa795-9cb7-4cfa-9353-6833354e4725.png?v=obnwksujsur-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/90afa795-9cb7-4cfa-9353-6833354e4725.png?v=obnwksujsur-wvc-sizes",
  alt: "House 303 evening exterior and reflection pool courtyard"
}, {
  id: "project-3",
  title: "The Bridge House",
  location: "Michigan, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/89231070-f70b-44f1-8f1c-fd6c080dd978-1.png?v=n75wgy4w8kb",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/89231070-f70b-44f1-8f1c-fd6c080dd978-1.png?v=n75wgy4w8kb-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/89231070-f70b-44f1-8f1c-fd6c080dd978-1.png?v=n75wgy4w8kb-wvc-sizes",
  alt: "The Bridge House panoramic residence overlooking mountain and city"
}, {
  id: "project-4",
  title: "The Play Loft",
  location: "Upper Peninsula, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/7f9ccfc3-a6b8-48a8-aaf5-44e960c79938.png?v=2o5jbyp7hsu",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/7f9ccfc3-a6b8-48a8-aaf5-44e960c79938.png?v=2o5jbyp7hsu-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/7f9ccfc3-a6b8-48a8-aaf5-44e960c79938.png?v=2o5jbyp7hsu-wvc-sizes",
  alt: "The Play Loft bespoke sculptural wine cellar and travertine lounge"
}, {
  id: "project-5",
  title: "Curated Stays",
  location: "Short Term Rentals, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/airbnb-1-1.png?v=4wospf0bofe",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/airbnb-1-1.png?v=4wospf0bofe-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/airbnb-1-1.png?v=4wospf0bofe-wvc-sizes",
  alt: "The Curated Stay modern open-concept living area with full-height glazing"
}, {
  id: "project-6",
  title: "Forest Hill",
  location: "Coming Soon",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/High-resolution-renovation-rendering-noon-scaled.png?v=9cvy0z7eyfp",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/High-resolution-renovation-rendering-noon-scaled.png?v=9cvy0z7eyfp-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/High-resolution-renovation-rendering-noon-scaled.png?v=9cvy0z7eyfp-wvc-sizes",
  alt: "Forest Hill master suite with unobstructed ocean sunset views"
}, {
  id: "project-7",
  title: "Table Blanc",
  location: "Coming Soon",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Table-Blanc-exterior.png?v=9pfimqtpfam",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Table-Blanc-exterior.png?v=9pfimqtpfam-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Table-Blanc-exterior.png?v=9pfimqtpfam-wvc-sizes",
  alt: "Hatta desert retreat luxury pavilion bedroom and lounge"
}, {
  id: "project-8",
  title: "Derm Society",
  location: "Coming Soon",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Derm-Society-interior.jpeg?v=lkc84b0ijd",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Derm-Society-interior.jpeg?v=lkc84b0ijd-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Derm-Society-interior.jpeg?v=lkc84b0ijd-wvc-sizes",
  alt: "Waterside bespoke custom furniture and warm timber panelling"
}];
export default function Showcase() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const prefersReducedMotion = useReducedMotion();
  const currentProject = projects[selectedIndex] || projects[0];
  return <section id="studioprojectsshowcase" data-nav="light" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-start gap-10 lg:gap-16">
          {/* Left Column: Project Navigation */}
          <div className="w-full lg:w-1/4 shrink-0 flex flex-col space-y-6">
            <h2 className="text-[11px] tracking-[0.22em] text-muted-foreground uppercase font-sans font-medium">
              Projects
            </h2>

            <nav aria-label="Studio projects list" className="flex flex-col space-y-1 sm:space-y-2">
              {projects.map((project, i) => {
              const isActive = selectedIndex === i;
              return <div key={project.id} data-index={i} className="w-full">
                    <Button variant="ghost" onClick={() => setSelectedIndex(i)} className={`w-full justify-start text-left h-auto py-2 px-0 bg-transparent hover:bg-transparent shadow-none rounded-none text-xs uppercase tracking-wider transition-colors duration-200 ${isActive ? "text-foreground font-normal" : "text-muted-foreground font-light hover:text-foreground"}`}>
                      <span className="truncate">{project.title}</span>
                    </Button>
                  </div>;
            })}
            </nav>
          </div>

          {/* Right Column: Interactive Featured Image Display */}
          <div className="w-full lg:w-3/4">
            <div className="relative overflow-hidden group bg-muted aspect-[16/10] w-full">
              <AnimatePresence mode="wait">
                <motion.div key={currentProject.id} initial={prefersReducedMotion ? {
                opacity: 1
              } : {
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={prefersReducedMotion ? {
                opacity: 1
              } : {
                opacity: 0
              }} transition={{
                duration: 0.45,
                ease: "easeInOut"
              }} className="absolute inset-0 w-full h-full">
                  <AspectRatio ratio={16 / 10} className="w-full h-full">
                    <img src={currentProject.imageSrc} data-wvc-srcset={currentProject.imageSrcset} data-wvc-sizes={currentProject.imageSizes} alt={currentProject.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]" />
                  </AspectRatio>

                  {/* Gradient Overlay & Project Details Caption */}
                  <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/60 via-black/25 to-transparent pointer-events-none" />

                  <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10 text-white space-y-1 max-w-[85%]">
                    <h3 className="font-serif text-lg md:text-2xl font-normal tracking-wide leading-snug drop-shadow-sm">
                      {currentProject.title}
                    </h3>
                    <p className="text-[11px] md:text-xs tracking-[0.18em] uppercase opacity-90 drop-shadow-sm font-sans font-light">
                      {currentProject.location}
                    </p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>;
}